import type { MarketGroupCategory, SelectedData } from '../components/molecules/MarketGroupCategories';

export type ResolvedTournamentMarketGroup = Required<Pick<SelectedData, 'id' | 'name'>> & {
  index: number;
};

export const flattenTournamentMarketGroups = (
  marketGroupsData?: MarketGroupCategory[]
): ResolvedTournamentMarketGroup[] =>
  marketGroupsData?.flatMap((category, index) =>
    category.marketTypeGroups.map((group) => ({
      id: group.id,
      name: group.name,
      index,
    }))
  ) ?? [];

export const resolveTournamentMarketGroup = (
  marketGroupsData?: MarketGroupCategory[],
  selectedGroupId?: string
): ResolvedTournamentMarketGroup | undefined => {
  const marketGroupOptions = flattenTournamentMarketGroups(marketGroupsData);

  if (!marketGroupOptions.length) {
    return undefined;
  }

  return marketGroupOptions.find((group) => group.id === selectedGroupId) ?? marketGroupOptions[0];
};
